import { Navigate } from 'react-router-dom'
import React from 'react'

import { LocalStorageKeys, RoutesPath } from 'src/types'

import { DefaultComponentProps } from '../AppProviders/types'

const ProtectedRoute: React.FC<DefaultComponentProps> = ({ children }) => {
  const isAuthenticated = localStorage.getItem(LocalStorageKeys.AUTH_TOKEN)

  return isAuthenticated ? children : <Navigate to={RoutesPath.LOGIN} />
}

export default ProtectedRoute
